import apiHttpClient from "./ApiHttpService";

export default class NotificationService {
  getUnSeenNotifications() {
    return apiHttpClient.get(`trs/mobile/notification/getUnSeenNotifications`);
  }
  seenNotifications(notificationIds) {
    return apiHttpClient.post(
      `trs/mobile/notification/seenNotifications`,
      notificationIds
    );
  }
  getNotifications() {
    return apiHttpClient.get(`trs/mobile/notification/getNotifications`);
  }
}
